import { useState } from "react"

export const Training = () => {
	const [trngForm, setTrngForm] = useState(/*{
		bgimage: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553024530.jpg' },
		logos: [
			{ value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720810.png' }, 
			{ value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720820.png' }
		],
		heading: { value: 'RE-run', color: '#177E0D', stat: false },
		sub_heading: { value: 'EPR 2025 DEADLINE SUBMISSION', color: '#177E0D', stat: false },
		title: { value: "Don't Miss the 2025 EPR Filing Deadline - What You Need To Know", color: '#292C2F', stat: false },
		speakers: [
			{
				img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720818.jpg' },
				name: { value: 'ISABELLA MARIE D. REYES, CPA', color: '#292C2F', stat: false },
				description: { value: 'Audit Manager, Financial Advisory Head', color: '#292C2F', stat: false },
				company: { value: 'Santos & Delos Reyes Accounting Firm', color: '#292C2F', stat: false },
				border: { color: '#009F4D' }
			},
			{   
				img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720815.jpg' },
				name: { value: 'JUAN MIGUEL P. CRUZ, MBA', color: '#292C2F', stat: false },
				description: { value: 'Managing Partner, Business Strategy Head', color: '#292C2F', stat: false },
				company: { value: 'Cruz & Associates Consulting', color: '#292C2F', stat: false },
				border: { color: '#009F4D' }
			}
		],
		button: { value: 'Register Now', color: '#ffffff', bg_color: '#1BAC0D', stat: false },
		calendar: { color: '#8EEEFD', border_color: '#FFFFFF', bg_color: '#070606' },
		time: { value: '10:00 AM - 12:NN', color: '#ffffff', stat: false },
		date: { value: 'June 16 & 23, 2025', color: '#ffffff', stat: false },
		location: { value: 'Ortigas, Pasig City', color: '#ffffff', stat: false },
		dis_and_ins_title: { value: 'Discussion and Insights', color: '#FFFBFB' },
		dis_and_ins: { value: "<ul><li>Clear walkthrough of what's required under EPR</li><li>Practical guidance on how to file correctly</li><li>What will the Audit Requirements Be</li><li>The Basics of EPR Law</li></ul>", color: '#FFFBFB', stat: false },
		violator: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1753766821543.png', show: false },
		divider: { bg_color: '#FFFBFB' },
		footer: { bg_color: '#052702' },
		poster_name: { value: '', stat: false }
	}*/);
	const [trngCustom, setTrngCustom] = useState('');
	const [trngModals, setTrngModals] = useState({ confirmation: false, success: false });
	const [trngLoaders, setTrngLoaders] = useState({ init: false, submit: false });
	const [trngSavingType, setTrngSavingType] = useState('');
	const trngNewSpkr = {
		img: { value: 'https://marketing-system-repo.s3.amazonaws.com/mt/phases/1754553720818.jpg' },
		name: { value: 'ISABELLA MARIE D. REYES, CPA', color: '#292C2F', stat: false },
		description: { value: 'Audit Manager, Financial Advisory Head', color: '#292C2F', stat: false },
		company: { value: 'Santos & Delos Reyes Accounting Firm', color: '#292C2F', stat: false },
		border: { color: '#009F4D' }
	}
	const [trngError, setTrngError] = useState(false)
	const [trngSlctdTmplt, setTrngSlctdTmplt] = useState({});
	const [trngTabsErr, setTrngTabsErr] = useState({ content: false, details: false, tabs: false })
	return {
		trngForm: {data: trngForm, set: setTrngForm},
		trngCustom: {data: trngCustom, set: setTrngCustom},
		trngModals: {data: trngModals, set: setTrngModals},
		trngLoaders: {data: trngLoaders, set: setTrngLoaders},
		trngSavingType: {data: trngSavingType, set: setTrngSavingType},
		trngNewSpkr: {data: trngNewSpkr},
		trngError: {data: trngError, set: setTrngError},
		trngSlctdTmplt: {data: trngSlctdTmplt, set: setTrngSlctdTmplt},
		trngTabsErr: {data: trngTabsErr, set: setTrngTabsErr},
	}
}
